import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    changeLawsysId,
    changeSelectedSolicitorUsers,
    changeSolicitorUsersListSettings,
    changeSolicitorDisplayedUsers,
    checkAllSolicitorUsers,
    checkSolicitorUser,
    filterByLawsys,
    requestGetSolicitors,
    requestUpdateCheckedSolicitors,
    solicitorUsersAgentsFilter,
    solicitorUsersPageShift,
    toggleModal,
    toggleConfirmDialog,
    changeAgentsListSettings,
    requestGetSolicitorsSuggestions,
    receiveGetSolicitors, sortAgentsList,
} from "../actions/agentsList";
import AgentsList from '../components/agentsList';
import { push } from 'connected-react-router'
import {requestLawsysFirmsWithAgents} from "../actions/lawsysFirms";
import _ from 'lodash';
import {changeNewSolicitorProperties, requestPatchExistingSolicitor} from "../actions/newSolicitor";


class AgentsListHOC extends Component {
    constructor(props) {
        super(props);
        let askServer;
    }

    componentWillMount() {
        const parameters = this.getParameters(this.props);
        this.askServer = setTimeout(() => {
            this.props.getSolicitors(parameters)
        }, 0);
        this.props.getSolicitors(parameters);
        
        this.props.fetchLawsys(this.props.user.loggedInUser.token);
    }


    componentWillReceiveProps(nextProps) {
        clearTimeout(this.askServer);
        if (
            this.props.agentsList.solicitorUsersListSettings.displayAmount !== nextProps.agentsList.solicitorUsersListSettings.displayAmount ||
            this.props.agentsList.filterBySolicitor !== nextProps.agentsList.filterBySolicitor ||
            this.props.agentsList.solicitorUsersListSettings.value !== nextProps.agentsList.solicitorUsersListSettings.value ||
            this.props.agentsList.solicitorUsersListSettings.page !== nextProps.agentsList.solicitorUsersListSettings.page ||
            this.props.agentsList.solicitorUsersListSettings.sortOrder !== nextProps.agentsList.solicitorUsersListSettings.sortOrder ||
            this.props.agentsList.solicitorUsersListSettings.sortBy !== nextProps.agentsList.solicitorUsersListSettings.sortBy
        ) {
            const parameters = this.getParameters(nextProps);
            if (this.props.agentsList.solicitorUsersListSettings.value !== nextProps.agentsList.solicitorUsersListSettings.value &&
                nextProps.agentsList.solicitorUsersListSettings.value !== ''
            ) {
                parameters.offset = 0;
                parameters.limit = 5;
                this.askServer = setTimeout(() => {
                    this.props.getSolicitorsSuggestions(parameters)
                }, 50);
            } else {
                this.props.getSolicitors(parameters);
            }
        }


    }

    getParameters = (props) => {
        const calcOffset = props.agentsList.solicitorUsersListSettings.displayAmount * (props.agentsList.solicitorUsersListSettings.page - 1);
        const parameters = {
            orderAsc: props.agentsList.solicitorUsersListSettings.sortOrder === 'asc',
            orderBySolicitorName:  props.agentsList.solicitorUsersListSettings.sortBy ===  'orderBySolicitorName',
            orderByLawsysId:  props.agentsList.solicitorUsersListSettings.sortBy ===  'orderByLawsysId',
            orderByLawsysName:  props.agentsList.solicitorUsersListSettings.sortBy ===  'orderByLawsysName',
            orderByUserName:  props.agentsList.solicitorUsersListSettings.sortBy === 'orderByUserName' ,
            limit: props.agentsList.solicitorUsersListSettings.displayAmount,
            offset: calcOffset > 0 ? calcOffset : 0,
            lawsysId: props.agentsList.filterBySolicitor === "noFilter" ? 0 : props.agentsList.filterBySolicitor,
            search: props.agentsList.solicitorUsersListSettings.value === '' ? null : props.agentsList.solicitorUsersListSettings.value,
        };
        return parameters;
    };

    // function called when user tries to log in with submit button
    //action will be called to talk to the api
    HandleUserLoginFormSubmit = (evt) => {
        evt.preventDefault();
        this.props.logIn(this.props.user.loginFormData);
    };

    //function to confirm lawsys attach to the modal
    confirmChanges = () => {
        if (this.props.agentsList.selectedLawsysId !== '') {
            this.props.displayConfirm()
        }
    };

    handleSolicitorSelect = (evt, url, item) => {
        if(evt.button === 1){
            window.open(url, '_blank');
        } else {
            this.props.push(url);
        }
    };


    calculateLawsysName = (lawsysId) => {
        let lawsysFirms = this.props.lawsysFirms.lawsysFirms;
        let lawsys = _.filter(lawsysFirms, (lawsys) => {
            return lawsys.id === parseInt(lawsysId);
        });
        if (lawsys[0])
            return lawsys[0].name;
        else return '';
    };

    handleStatusChange = () => {
        let solicitors = this.props.agentsList.selectedSolicitorUsers;

        let status = false;
        if (this.props.agentsList.solicitorUsersListSettings.action === 'enable') {
            status = true;
        }
        else if (this.props.agentsList.solicitorUsersListSettings.action === 'disable') {
            status = false;
        }
        for (let i in solicitors) {
            this.props.requestPatchExistingSolicitor({
                status: status,
                userId: solicitors[i].userId
            }, solicitors[i].userId)
        }
    };

    handleApplyActions = () => {
        if (
            this.props.agentsList.solicitorUsersListSettings.action !== ""
            && (Object.keys(this.props.agentsList.selectedSolicitorUsers).length > 0)
        ){
            if (this.props.agentsList.changeLawsys === true){
                this.props.displayModal()
            }
            else {
                this.handleStatusChange()
            }
        }
    };

    onQuickSearch = () => {
        const parameters = this.getParameters(this.props);
        this.props.getSolicitors(parameters)
    };

    render() {
        return (
            <AgentsList
                handleApplyActions={this.handleApplyActions}
                onQuickSearch={this.onQuickSearch}
                selectedLawsysId={this.props.agentsList.selectedLawsysId}
                selectedSolicitorUsers={this.props.agentsList.selectedSolicitorUsers}
                changeAgentsListSettings={this.props.changeAgentsListSettings}
                calculateLawsysName={this.calculateLawsysName}
                user={this.props.user}
                push={this.props.push}
                HandleSolicitorSelect={this.handleSolicitorSelect}
                DisplayConfirm={this.confirmChanges}
                ChangeSolicitorsStatus={this.handleStatusChange}
                SelectLawsysId={this.props.selectLawsysId}
                AttachLawsys={this.attachSolicitorFirm}
                DisplayModal={this.props.displayModal}
                FilterByLawsysId={this.props.filterByLawsysId}
                UpdateSolicitors={this.props.updateSolicitors}
                UpdateCheckedSolicitors={this.props.updateCheckedSolicitors}
                solicitorUsersAgentsFilter={this.props.solicitorUsersAgentsFilter}
                AgentsList={this.props.agentsList}
                lawsysFirms={this.props.lawsysFirms}
                solicitorUsersPagination={this.props.solicitorUsersPagination}
                SolicitorDisplaySetting={this.props.solicitorDisplaySetting}
                CheckAll={this.props.CheckAll}
                UpdateSolicitorsDisplayedUsers={this.props.updateSolicitorsDisplayedUsers}
                CheckSolicitor={this.props.addSolicitorUser}
                HandleNewSolicitor={this.props.newSolicitorProperties}
                DisplaySolicitorFormUsernameValidationError={this.props.displaySolicitorFormUsernameValidationError}
                DisplaySolicitorFormEmailValidationError={this.props.displaySolicitorFormEmailValidationError}
                DisplaySolicitorFormUsernameInfo={this.props.displaySolicitorFormUsernameInfo}
                DisplaySolicitorFormEmailInfo={this.props.displaySolicitorFormEmailInfo}
                DisplayAuthBox={this.HandleUserLoginFormSubmit}
                DisplayDialogBox={this.props.displayDialogBox}
                HandleInputChange={this.props.userLoginProperties}
                receiveGetSolicitors={this.props.receiveGetSolicitors}
                getSolicitors={this.props.getSolicitors}
                sortAgentsList={this.props.sortAgentsList}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        agentsList: state.agentsList,
        lawsysFirms: state.lawsysFirms,
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        addSolicitorUser: (payload) => {
            dispatch(checkSolicitorUser(payload))
        },
        updateSolicitorsDisplayedUsers: (data) => {
            dispatch(changeSolicitorDisplayedUsers(data))
        },
        CheckAll: (payload) => {
            dispatch(checkAllSolicitorUsers(payload))
        },
        solicitorDisplaySetting: (settingKey, value) => {
            dispatch(changeSolicitorUsersListSettings(settingKey, value))
        },
        solicitorUsersPagination: (direction) => {
            dispatch(solicitorUsersPageShift(direction))
        },
        solicitorUsersAgentsFilter: (filteredAgents) => {
            dispatch(solicitorUsersAgentsFilter(filteredAgents))
        },
        updateCheckedSolicitors: (property) => {
            dispatch(changeSelectedSolicitorUsers(property))
        },
        updateSolicitors: (solicitors) => {
            dispatch(requestUpdateCheckedSolicitors(solicitors))
        },
        getSolicitors: (payload) => {
            dispatch(requestGetSolicitors(payload))
        },
        getSolicitorsSuggestions: (payload) => {
            dispatch(requestGetSolicitorsSuggestions(payload))
        },
        fetchLawsys: (token) => {
            dispatch(requestLawsysFirmsWithAgents(token))
        },
        filterByLawsysId: (id) => {
            dispatch(filterByLawsys(id))
        },
        displayModal: () => {
            dispatch(toggleModal())
        },
        selectLawsysId: (id) => {
            dispatch(changeLawsysId(id))
        },
        displayConfirm: () => {
            dispatch(toggleConfirmDialog())
        },
        push: (url) => {
            dispatch(push(url))
        },
        changeAgentsListSettings: (key, value) => {
            dispatch(changeAgentsListSettings(key, value))
        },
        requestPatchExistingSolicitor: (solicitor, id) => {
            dispatch(requestPatchExistingSolicitor(solicitor, id))
        },
        receiveGetSolicitors: (payload) => {
            dispatch(receiveGetSolicitors(payload))
        },
        newSolicitorProperties: (property, value) => {
            dispatch(changeNewSolicitorProperties(property, value))
        },
        sortAgentsList: (payload) => {
            dispatch(sortAgentsList(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AgentsListHOC);
